const PAYMENT_PLATFORM = Object.freeze({
  STRIPE: "STR",
  REDSYS: "RED",
});

export default Object.freeze({
  PAYMENT_PLATFORM: PAYMENT_PLATFORM,
});
